import React from "react";

import type { Time } from "~/tools/date-time/time";
import { type Impulse, useScope } from "~/tools/impulse";

import { SpecificRange, type TimeRange } from "../../app/state/view/timeline/TimeRange";
import type { MonitorCheckStatusHealthChange } from "../../common/openapi";
import { Timeline, TimelineHealthState, TimelineTimeTicks } from "../_timeline";

interface HealthTimelineChartProps {
	disabled?: boolean;
	timestamp: Impulse<undefined | Time>;
	timeRange: Impulse<TimeRange>;
	health: undefined | ReadonlyArray<MonitorCheckStatusHealthChange>;
}

export const HealthTimelineChart: React.FC<HealthTimelineChartProps> = React.memo(
	({ disabled, timestamp, timeRange, health }) => {
		const scope = useScope();

		return (
			<Timeline
				brush={{
					areaOffsetTop: 20,
					areaOffsetBottom: 5,
					onBrush: (left, right) => timeRange.setValue(new SpecificRange(left, right)),
				}}
				data-testid="health-timeline-chart"
				disabled={disabled || health == null}
				height={50}
				hideTopologyTimeMarker
				onClick={(time) => timestamp.setValue(time)}
				timeRange={timeRange.getValue(scope)}
				timestamp={timestamp.getValue(scope)}
			>
				<TimelineTimeTicks withTicks y={14} />
				<TimelineHealthState health={health} y={32} />
			</Timeline>
		);
	},
);
